module.exports = __webpack_public_path__ + "img/location_hotel.86f78e6b.svg";